
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';
import State from '../../../../docs/State';
import PopupTextCarousel from '@devsisters/ui-careers/lib/PopupTextCarousel';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"popuptextcarousel"}}>{`PopupTextCarousel`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import PopupTextCarousel from '@devsisters/ui-careers/lib/PopupTextCarousel';
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"놀이터"}}>{`놀이터`}</MDXTag>
<Playground __position={0} __code={'() => {\n  const slideTexts = [\n    {\n      title: (\n        <>\n          설산에서 굳세게 인생을 보라.\n          <br />\n          없으면 그들은 구할 싸인 그것을 같은 이것이다.\n        </>\n      ),\n      description: (\n        <>\n          인생을 수 용감하고 가슴에 말이다. 찬미를 영원히 곧 끝에 뿐이다.\n          가슴이 맺어, 가는 사막이다. 이상 청춘이 얼마나 되는 옷을 얼음이\n          부패뿐이다. 이는 방황하였으며, 석가는 주며, 트고, 그들의 실로 얼음과\n          있는 것이다. 새가 곳이 자신과 찾아 소담스러운 미묘한 귀는 천하를\n          가치를 듣는다. 구할 날카로우나 하는 속잎나고, 있는 칼이다. 모래뿐일\n          할지니, 희망의 힘차게 고행을 봄바람을 것이다.\n        </>\n      ),\n    },\n    {\n      title: <>되려니와, 그것은 공자는 같은 수 것이다.</>,\n      description: (\n        <>\n          속에서 청춘 얼마나 관현악이며, 동산에는 그들의 찾아다녀도, 그들은\n          생명을 부패뿐이다. 인간이 주는 목숨이 있는가? 보이는 때에, 것은\n          웅대한 하는 인간의 약동하다. 원대하고, 그와 찾아 청춘 있으며,\n          같으며, 심장의 예수는 것이다. 눈에 인생에 부패를 이것이다. 속에서\n          놀이 청춘이 구하기 그들은 우리 가치를 안고, 유소년에게서 황금시대다.\n          모래뿐일 우리의 굳세게 얼음과 봄바람이다.\n        </>\n      ),\n    },\n  ]\n  return [\'pc\', \'mobile\'].map(type => (\n    <React.Fragment key={type}>\n      <h1>{type}</h1>\n      <State initialState={{ open: false }}>\n        {({ state, setState }) => (\n          <>\n            <PopupTextCarousel\n              type={type}\n              style={{ zIndex: 10000 }}\n              open={state.open}\n              close={() => setState({ open: false })}\n              slideTexts={slideTexts}\n            />\n            <button onClick={() => setState({ open: true })}>열기</button>\n          </>\n        )}\n      </State>\n    </React.Fragment>\n  ))\n}'} __scope={{props: this ? this.props : props,State,PopupTextCarousel}}>
  {() => {
    const slideTexts = [
      {
        title: <>설산에서 굳세게 인생을 보라.<br/>없으면 그들은 구할 싸인 그것을 같은 이것이다.</>,
        description: <>인생을 수 용감하고 가슴에 말이다. 찬미를 영원히 곧 끝에 뿐이다. 가슴이 맺어, 가는 사막이다. 이상 청춘이 얼마나 되는 옷을 얼음이 부패뿐이다. 이는 방황하였으며, 석가는 주며, 트고, 그들의 실로 얼음과 있는 것이다. 새가 곳이 자신과 찾아 소담스러운 미묘한 귀는 천하를 가치를 듣는다. 구할 날카로우나 하는 속잎나고, 있는 칼이다. 모래뿐일 할지니, 희망의 힘차게 고행을 봄바람을 것이다.</>,
      },
      {
        title: <>되려니와, 그것은 공자는 같은 수 것이다.</>,
        description: <>속에서 청춘 얼마나 관현악이며, 동산에는 그들의 찾아다녀도, 그들은 생명을 부패뿐이다. 인간이 주는 목숨이 있는가? 보이는 때에, 것은 웅대한 하는 인간의 약동하다. 원대하고, 그와 찾아 청춘 있으며, 같으며, 심장의 예수는 것이다. 눈에 인생에 부패를 이것이다. 속에서 놀이 청춘이 구하기 그들은 우리 가치를 안고, 유소년에게서 황금시대다. 모래뿐일 우리의 굳세게 얼음과 봄바람이다.</>,
      },
    ];
    return ['pc', 'mobile'].map(type => <React.Fragment key={type}>
      <h1>{type}</h1>
      <State initialState={{ open: false }}>
        {({ state, setState }) => <>
          <PopupTextCarousel
            type={type}
            style={{ zIndex: 10000 }}
            open={state.open}
            close={() => setState({ open: false })}
            slideTexts={slideTexts}
          />
          <button onClick={() => setState({ open: true })}>열기</button>
        </>}
      </State>
    </React.Fragment>);
  }}
</Playground>
           </MDXTag>
  }
}
  